import { apiFetcher } from 'src/lib/api/data'
import { API_PACKS_PATH } from 'src/lib/constants/routes'
import {
  Blur,
  Box,
  Loader,
  Modal
} from '@climatetradecarbon/climatetrade-components'
import { useEffect, useState } from 'react'
import { Pack } from 'src/core/models/pack'
import CalculatorCard from './components/CalculatorCard'
import { CalculatorsProps } from './Calculators.props'
import { useTranslation } from 'next-i18next'
import Calculator from '../calculator/Calculator'

/**
 *
 * @returns The calculators scene
 */
export default function Calculators({ open, onClose }: CalculatorsProps) {
  const { t } = useTranslation()

  const [loading, setLoading] = useState<boolean>(false)

  const [calculators, setCalculators] = useState<Pack[]>([])

  const [calculator, setCalculator] = useState<string>()

  useEffect(() => {
    const fetchCalculators = async () => {
      setLoading(true)
      const { data } = await apiFetcher(API_PACKS_PATH)
      setCalculators(data.packs)
      setLoading(false)
    }

    fetchCalculators()
  }, [])

  return loading ? (
    <Blur>
      <Loader />
    </Blur>
  ) : (
    <Modal
      title={t('footPrint.CalculateButton')}
      onClose={onClose}
      open={open}
    >
      {calculator ? (
        <Calculator
          name={calculator}
          onClose={() => setCalculator(null)}
        />
      ) : (
        calculators && (
          <Box>
            {calculators.map((calculator: Pack) => (
              <CalculatorCard
                key={calculator.name}
                openCalculator={() =>
                  setCalculator(calculator.name)
                }
                pack={calculator}
              />
            ))}
          </Box>
        )
      )}
    </Modal>
  )
}
